<template>
  <p>{{ moveHistoryString }}</p>
</template>

<script setup>

  import { ref } from "vue"
  import { watch } from "vue";
  import { computed } from "@vue/reactivity"

  const moveHistoryString = ref("")

  const emit = defineEmits(['move-history-string'])

  const props = defineProps({
    moveHistoryStack : Array,
    trigger : Number,
    noAvailableMovesFlag : {
      type : Number,
      default : 0
    },
    firstMoveNumber : {
      type : Number,
      default : 1
    },
    firstMoveColor : {
      type : String,
      default : "white"
    },
    prefixString : {
      type : String,
      default : ""
    }
  })
 
  const trigger = computed({
    get() {
      return props.trigger
    }
  })

  watch(trigger, (newVal,oldVal) => {
    //console.log("**** MOVE HISTORY TRIGGER",newVal)
    buildMoveHistory()
  })

  function buildMoveHistory() {
    var moveNumber = props.firstMoveNumber
    var isWhite = (props.firstMoveColor != "black")
    var whiteString = ""
    var blackString = ""
    var moveHistoryArray = []
    moveHistoryString.value = props.prefixString
    //console.log("in buildmovehistory",props.moveHistoryStack)
    for (var i=0; i < props.moveHistoryStack.length; i++) {
      
      if (isWhite) {
        whiteString = (props.firstMoveColor != "none") ? moveNumber + ". " : ""
        whiteString += props.moveHistoryStack[i].san
      }
      else {
        blackString = (i == 0 && props.firstMoveColor == "black") ? "1... " : ""
        blackString += props.moveHistoryStack[i].san
        moveHistoryString.value += whiteString + " " + blackString + "  "
        moveHistoryArray.push({ white : whiteString, black : blackString})
        moveNumber++
      }
      isWhite = !isWhite
    }
    if (isWhite == false) {
      moveHistoryString.value += whiteString
      moveHistoryArray.push({ white : whiteString, black : "" })
    }

    //console.log("move history string",moveHistoryString.value)
    emit('move-history-string',moveHistoryString.value)
    
    if (props.moveHistoryStack.length > 0) {
      const lastMove = props.moveHistoryStack[props.moveHistoryStack.length -1]
      //console.log("LAST MOVE IN HISTORY",lastMove.san,lastMove.comment)

      const lastComment = props.moveHistoryStack[props.moveHistoryStack.length -1].comment
      if (lastComment != undefined && lastComment != "")
        moveHistoryString.value += " { " + lastComment + " } "
    }

    if (props.noAvailableMovesFlag > 0)
      moveHistoryString.value += (props.noAvailableMovesFlag == 1) ? " ** No More Opponent Moves **" :
                          " ** No More Player Moves **"
  }
  
  if (props.moveHistoryStack.length > 0)
    buildMoveHistory()
</script>